import { combineReducers } from 'redux'
import app from '@reducers/app'
import data from '@reducers/data'
import appointments from '@reducers/appointments'
import types from '@reducers/types'
import stores from '@reducers/stores'
import filteredStores from '@reducers/filteredStores'
import fields from '@reducers/fields'

export default combineReducers({
  app,
  data,
  appointments,
  types,
  stores,
  filteredStores,
  fields,
})
